import { render, staticRenderFns } from "./acpages.vue?vue&type=template&id=c8c10c90&scoped=true&"
import script from "./acpages.vue?vue&type=script&lang=js&"
export * from "./acpages.vue?vue&type=script&lang=js&"
import style0 from "./acpages.vue?vue&type=style&index=0&id=c8c10c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c10c90",
  null
  
)

export default component.exports